import { IGetDataCronogramaSGQDropDownUseCase } from "../../../presentation/useCases/read/get_data_cronogramaSGQ_drop_down_use_case";
import { DataCronogramaSGQDropDown } from "../../models/data_cronogramaSGQ__dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

//GetDatCronogramaSGQDropDownUseCase

export class GetDatCronogramaSGQDropDownUseCase implements IGetDataCronogramaSGQDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getDataCronogramaSGQDropDown(Tipo: "DataPrevista" | "DataRealizada"): Promise<DataCronogramaSGQDropDown[]> {
    return await this.repository.getDataCronogramaSGQDropDown(Tipo);
  }
}
